// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Switzerland from '../_raw/flag/icon_flag_switzerland.png';

export default () => <img src={Switzerland} alt="Switzerland" />;
